import api from "../axiosIntercepture";

/* ================= CREATE MENU (MODULE / CHILD) ================= */

export const createMenu = async (payload) => {
    try {
        const response = await api.post("global/create-menu", payload);

        if (response.data?.success) {
            return response.data.data || {};
        }

        const message = response.data?.message || "Failed to create menu";
        throw new Error(message);
    } catch (err) {
        console.error("Error creating menu:", err);

        let errorMessage = "Failed to create menu";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        throw new Error(errorMessage);
    }
};

/* ================= UPDATE MENU ================= */

export const updateMenu = async (id, payload) => {
    if (!id) throw new Error("Missing id for updateMenu");

    try {
        const response = await api.post(`menu/update/${id}`, payload);

        if (response.data?.success) {
            return response.data.data || {};
        }

        const message = response.data?.message || "Failed to update menu";
        throw new Error(message);
    } catch (err) {
        console.error("Error updating menu:", err);

        let errorMessage = "Failed to update menu";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        throw new Error(errorMessage);
    }
};

/* ================= GET ALL MODULES (ADMIN / TENANT) ================= */

export const getAllModules = async () => {
    try {
        const response = await api.get("menu/get-all-modules");

        if (response.data?.success) {
            return Array.isArray(response.data?.data)
                ? response.data.data
                : [];
        }

        const message = response.data?.message || "Failed to fetch modules";
        throw new Error(message);
    } catch (err) {
        console.error("Error fetching modules:", err);
        throw new Error(err?.response?.data?.message || "Failed to fetch modules");
    }
};

/* ================= GET MENU (TREE) ================= */

export const getMenu = async () => {
    try {
        const response = await api.get("menu/get-menu");

        if (response.data?.success) {
            return response.data.data || [];
        }

        const message = response.data?.message || "Failed to fetch menu";
        throw new Error(message);
    } catch (err) {
        console.error("Error fetching menu:", err);
        throw new Error(err?.response?.data?.message || "Failed to fetch menu");
    }
};

/* ================= GET ROLE BASED MENU ================= */

export const getMenuBasedOnRole = async () => {
    try {
        const response = await api.get("menu/get-menu-based-on-role");

        if (response.data?.success) {
            return response.data.data || [];
        }

        const message = response.data?.message || "Failed to fetch role menu";
        throw new Error(message);
    } catch (err) {
        console.error("Error fetching role based menu:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to fetch role based menu"
        );
    }
};


export const deleteMenu = async (id) => {
    if (!id) throw new Error("Menu id required");

    try {
        const response = await api.delete(`global/delete-menu/${id}`);

        if (response.data?.success) {
            return true;
        }

        throw new Error(response.data?.message || "Delete failed");
    } catch (err) {
        console.error("DELETE MENU ERROR:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to delete menu"
        );
    }
};
